<template src="./index.html"></template>

<script>
import { URL, apiCall } from "@/utils/api";
export default {
  name: "ReasonsModal",
  props: { visible: Boolean },
  data() {
    return {
      modalVisible: false,
      reasons: [],
    };
  },
  methods: {
    getReasons() {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "common/reasons",
      })
        .then((response) => {
          if (!response.data.error) {
            this.reasons = response.data.data;
          } else {
            this.$message.error(response.data.error.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("Xəta baş verdi");
        });
    },
    choose(reason) {
      this.$emit("select", reason);
      this.modalVisible = false;
    },
  },
  watch: {
    visible: function (newValue, oldValue) {
      this.modalVisible = this.visible;
      if (newValue) {
        this.getReasons();
      }
    },
    modalVisible: function () {
      if (!this.modalVisible) {
        this.$emit("afterClose");
      }
    },
  },
  created() {
    this.getReasons();
  },
};
</script>

<style lang="scss" scoped></style>
